/**
 * Waits for element to be available in the DOM
 * Source: https://stackoverflow.com/questions/5525071/how-to-wait-until-an-element-exists
 *
 * Uses the `document.getElementById` API to performantly check if an element exists in the DOM
 * @param selector An ID selector ( prefixed by # ) to be passed into document.getElementById
 */
export const waitForElementToLoad = (
  selector: string
): Promise<HTMLElement | unknown | null> => {
  return new Promise((resolve, reject) => {
    // Verify that the selector is a valid ID selector by checking for the # prefix,
    // and that it is not an empty selector (ie. '#')
    if (!selector.startsWith("#") || selector.length < 2) {
      return reject();
    }

    const id = selector.substring(1);

    if (document?.getElementById(id)) {
      return resolve(document.getElementById(id));
    }

    const observer = new MutationObserver(() => {
      if (document?.getElementById(id)) {
        resolve(document.getElementById(id));
        observer.disconnect();
      }
    });

    observer.observe(document?.body, {
      childList: true,
      subtree: true,
    });

    return null;
  }).catch(() => null);
};
